// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__6hTG9","Open":"SideDrawer_Open__11IyP","Close":"SideDrawer_Close__3VR9n","Logo":"SideDrawer_Logo__Nbxw_"};